import api from '../services/api';

const SESSION_KEY = 'website_visit_tracked';

/**
 * Record one public site visit per browser tab session (feeds Super Admin visit stats).
 * Skips superadmin routes so staff activity is not counted as customer traffic.
 */
export function trackWebsiteVisit(pathname = '') {
  if (typeof window === 'undefined') return;
  if (pathname.startsWith('/superadmin')) return;
  if (sessionStorage.getItem(SESSION_KEY)) return;

  sessionStorage.setItem(SESSION_KEY, '1');

  api.post('/website-visits/track').catch(() => {
    sessionStorage.removeItem(SESSION_KEY);
  });
}
